import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { gqlWorkOrderVersionObjects } from '../workOrderVersionQueries';

export const useWorkOrderVersionObjects = (workOrderId: number, withEffect = true) => {
    const variables = useMemo(() => ({ workOrderVersionId: workOrderId }), [workOrderId]);
    const dispatch = useDispatch();

    const [data, status, error, makeRequest] = useRequest({
        requestId: 'workOrderVersionObjects',
        query: gqlWorkOrderVersionObjects,
        variables,
        withEffect,
    });

    const refreshWorkOrderObjects = useCallback(() => {
        dispatch(makeRequest(variables));
    }, [dispatch, makeRequest, variables]);

    return [data?.uerWorkOrderVersionObjects?.items, status, error, refreshWorkOrderObjects, makeRequest];
};
